import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../../lib/i18n";
import { PHONE, PHONE_DISPLAY, EMAIL, ADDRESS, MAPS_URL } from "../../lib/api";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";

const Row = ({ label, value, href, testid, external }) => (
  <a href={href} target={external ? "_blank" : undefined} rel="noreferrer" data-testid={testid}
    className="group flex items-end justify-between gap-4 border-b border-ink/10 py-6 transition-colors hover:border-ink">
    <span>
      <span className="block font-mono text-[11px] uppercase tracking-[0.26em] text-slate-600">{label}</span>
      <span className="mt-2 block break-all font-display text-xl font-bold tracking-tight text-ink sm:text-3xl">{value}</span>
    </span>
    <ArrowUpRight className="h-6 w-6 shrink-0 text-ink transition-transform duration-500 group-hover:rotate-45" />
  </a>
);

export const Contact = () => {
  const { t } = useI18n();
  const c = t.contact;
  return (
    <section id="contact" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-28" data-testid="contact-section">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>{c.eyebrow}</Eyebrow>
            <SectionTitle title={c.title} accent={c.titleAccent} />
            <p className="mt-6 max-w-md text-base text-slate-700">{c.note}</p>
          </Reveal>
          <Reveal delay={0.1} className="mt-10">
            <Row label={c.phone} value={PHONE_DISPLAY} href={`tel:${PHONE}`} testid="contact-phone-link" />
            <Row label={c.email} value={EMAIL} href={`mailto:${EMAIL}`} testid="contact-email-link" />
            <Row label={c.address} value={ADDRESS} href={MAPS_URL} external testid="contact-address-link" />
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-6">
          <div className="relative h-[380px] overflow-hidden rounded-[28px] border border-ink/10 bg-white sm:h-[520px] lg:h-full lg:min-h-[560px]">
            <iframe
              title="CARS 99 Udine"
              src="https://www.google.com/maps?q=Via+Cividina+99,+33100+Udine+UD&output=embed"
              className="absolute inset-0 h-full w-full grayscale-[0.85] contrast-[1.05]"
              loading="lazy"
              data-testid="contact-map"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
